import React, { useState } from "react";
import AgentCallForm from "./AgentCallForm";
import AgentCallList from "./AgentCallList";

const AgentCall = () => {
  
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);
  const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
        <AgentCallForm
          addForm={setFromIsShown}
          update={upData}
          sId={serviceId}
        />
      ) : (
        <AgentCallList
          addForm={setFromIsShown}
          update={setUpData}
          sId={setServiceId}
        />
      )}
    </>
  );
};
export default AgentCall;
